import { Fund } from "~/models/fund";
import { useImageAttachment } from "~/hooks/useImageAttachment";
import { ListContainer } from "~/common/list/ListContainer";
import { FundItemCard } from "./funditem/FundItemCard";
import { FundItemCardImage } from "./funditem/FundItemCardImage";
import { FundViewTitle } from "./FundViewTitle";

export const FundCardsView = ({
  title,
  bannerImage,
  nonprofits,
  onClick,
}: {
  title: string;
  bannerImage?: number | null;
  nonprofits?: Fund[];
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const image = useImageAttachment(bannerImage ?? undefined, "large");

  return (
    <ListContainer>
      <FundViewTitle title={title} onClick={onClick} />

      <div className="tw:gap-4 tw:md:grid tw:md:grid-cols-2 tw:xl:grid-cols-3">
        {nonprofits?.map((nonprofit: Fund) => (
          <div key={nonprofit.ein}>
            {bannerImage ? (
              <FundItemCardImage
                baseUrl={Environment.CN_URL}
                ein={nonprofit.ein}
                name={nonprofit.name}
                rating={nonprofit.encompass_score_total_display}
                starRating={nonprofit.encompass_star_rating}
                image={image}
                city={nonprofit.city}
                state={nonprofit.state}
                tags={nonprofit.tags}
                description={nonprofit.nonprofit_response}
              />
            ) : (
              <FundItemCard
                baseUrl={Environment.CN_URL}
                ein={nonprofit.ein}
                name={nonprofit.name}
                rating={nonprofit.encompass_score_total_display}
                starRating={nonprofit.encompass_star_rating}
                donationWeight={nonprofit.donation_weight}
                city={nonprofit.city}
                state={nonprofit.state}
                tags={nonprofit.tags}
                description={nonprofit.nonprofit_response}
              />
            )}
          </div>
        ))}
      </div>
    </ListContainer>
  );
};
